/* eslint react/prop-types: 0 */
import React from 'react';
import IndustryTypeMarkerConfigAccordion from '../IndustryTypeMarkerConfigAccordion';
import { defaultExecutiveMarker } from '../../../services/GMap/executiveMarker';

const ExecutiveEntityMarkerConfigAccordion = ({
  onEditMode,
  entities,
  markers,
  setMarkers
}) => (
  <IndustryTypeMarkerConfigAccordion
    label="Executive Entity Markers"
    emptyMessage="No executive entity markers configured."
    onEditMode={onEditMode}
    defaultMarker={defaultExecutiveMarker}
    industryTypeList={entities}
    industryTypeIcons={markers}
    setIndustryTypeIcons={setMarkers}
  />
);

export default ExecutiveEntityMarkerConfigAccordion;
